import { Link } from 'react-router';
import { cn } from '../ui';

/** The two ways to look at the one list of items: one row per item, or one row per lot (item, colour and condition). */
export function ItemsViewSwitch({ view }: { view: 'items' | 'lots' }) {
  const base = 'px-3 py-1.5 text-sm font-medium';
  return (
    <div role="group" aria-label="View" className="inline-flex overflow-hidden rounded-md ring-1 ring-slate-300">
      <Link to="/items" aria-current={view === 'items'} className={cn(base, view === 'items' ? 'bg-slate-900 text-white' : 'bg-white text-slate-700 hover:bg-slate-50')}>
        By item
      </Link>
      <Link to="/items?view=lots" aria-current={view === 'lots'} className={cn(base, 'border-l border-slate-300', view === 'lots' ? 'bg-slate-900 text-white' : 'bg-white text-slate-700 hover:bg-slate-50')}>
        By lot
      </Link>
    </div>
  );
}
